// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2849":"ccc11b97b2c2a7af","4967":"42ee2efbcbeb18e7","6233":"54795220be7b6b2b","7425":"a0e021c7f78911fc"}[chunkId] + ".css";
};